var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 15.9953,
    viewBox: "0 0 32 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 0H16C7.16353 0 1.46313e-05 7.16143 1.46313e-05 15.9953H16C24.8365 15.9953 32 8.8339 32 0Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 7.99753H8.04044C3.59987 7.99753 0 11.5782 0 15.9952H7.95956C12.4003 15.9952 16 12.4145 16 7.99753Z",
    fill: "#D6A102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif06);
export default __webpack_public_path__ + "static/media/motif-06.55fc39182d22c997ad8ac1b05506ee9c.svg";
export { ForwardRef as ReactComponent };